export default __webpack_public_path__ + "static/media/fb-logo.ed61c55b.svg";